import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const LogoutButton = ({ className = '', children }) => {
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        setIsLoggingOut(true);
        try {
            await logout();
            navigate('/auth/login');
        } catch (error) {
            console.error('Logout error:', error);
            // Even if logout fails, redirect to login page
            navigate('/auth/login');
        } finally {
            setIsLoggingOut(false);
        }
    };

    return (
        <button
            onClick={handleLogout}
            disabled={isLoggingOut}
            className={`text-gray-700 hover:text-primary transition-colors disabled:opacity-50 ${className}`}
        >
            {children || (isLoggingOut ? 'Signing Out...' : 'Sign Out')}
        </button>
    );
};

export default LogoutButton; 